import { render } from "./LanguageSwitch.vue?vue&type=template&id=21c0564e&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=21c0564e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c0564e"]])

export default __exports__